import { createAnimations } from '@tamagui/animations-css'

export const animations = createAnimations({
  fast: { type: 'timing', duration: 150 },
  medium: { type: 'timing', duration: 300 },
  slow: { type: 'timing', duration: 500 },
  bouncy: { type: 'spring', damping: 10, mass: 0.9, stiffness: 100 },
  lazy: { type: 'spring', damping: 20, stiffness: 60 },
})


